import { createStrictSchema } from '../../utils/morph.js';

const conversationIDSchema = (body) => body instanceof Object &&
    '_embedded' in body &&
    body._embedded instanceof Object &&
    'conversations' in body._embedded &&
    Array.isArray(body._embedded.conversations) &&
    body._embedded.conversations.length > 0 &&
    typeof body._embedded.conversations[0].conversationId === 'string'
    ? body._embedded.conversations[0].conversationId
    : null;
const unreadMessagesSchema = createStrictSchema({
    pollingTime: 'polling_time',
    unread: 'unread',
});
const sendFirstContactSchema = createStrictSchema({
    body: 'body',
    acceptTermsConds: 'accept_terms_conds',
});

export { conversationIDSchema, sendFirstContactSchema, unreadMessagesSchema };
//# sourceMappingURL=morph.js.map
